import { render } from "./Helper.vue?vue&type=template&id=474a2456"
import script from "./Helper.vue?vue&type=script&lang=js"
export * from "./Helper.vue?vue&type=script&lang=js"

import "./Helper.vue?vue&type=style&index=0&id=474a2456&lang=css"
script.render = render

export default script